export const userAccess = {
  wanderWriter: {
    label: 'Wander Writer',
    shortLabel: 'Writer',
    setButton: 'Set as Wander Writer',
    setTooltip: 'Set as Wander Writer',
    chipTooltip: 'Wander Writer: {{org}} · {{count}} pack(s). Click to edit packs.',
    chipLabelWithPacks: '{{org}} · {{count}} pack(s)',
    removeTooltip: 'Remove wander writer status',
    orgDialogTitle: 'Set User as Wander Writer',
    orgDialogSubtitle:
      'Choose which organisation this user should be a wander writer for. You will assign packs next.',
    orgDialogContinue: 'Continue',
    assignPacksTitle: 'Assign wander packs',
    editPacksTitle: 'Edit wander pack assignments',
    assignPacksSubtitle:
      'Choose which packs this writer can contribute to. Packs stay partner/admin-owned.',
    assignPacksRequiredHelp:
      'Select at least one pack. Writers can only add and edit wanders in packs they are assigned to.',
    assignPacksHelp: 'Writers can only add and edit wanders in packs they are assigned to.',
    packsLabel: 'Wander packs',
    packsPlaceholder: 'Search packs…',
    noPacks: 'No wander packs found. Create a new pack to get started.',
    packsLoadFailed: 'Failed to load wander packs. Please try again.',
    packsSaveFailed: 'Failed to save pack assignments. Please try again.',
    removeFailed: 'Failed to remove wander writer status. Please try again.',
    savePacks: 'Save pack assignments',
    grantConfirm: 'Set as Wander Writer',
    removeRole: 'Remove wander writer',
    newPack: 'Add new wander pack',
  },
};
